import { render, staticRenderFns } from "./RedirectSettingList.vue?vue&type=template&id=e3691636"
import script from "./RedirectSettingList.vue?vue&type=script&lang=js"
export * from "./RedirectSettingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports